<template>
    <div :class="['csSec',getPlatformClass]">
        <!--<div class="attachedLogo White"></div>-->
        <div class="sectionTitle black fsTitle">
          <!-- <splitter :content="ms_localize(sectionData.title)"></splitter> -->
          {{ms_localize(sectionData.title)}}
        </div>
        
        <div :class="['csImgCont', isImgFadeout===true  ? 'csImgFadeout' : '']">
          <div class="csImgItem" v-for="(item,index) in itemsArray" :key="index">
              <img :src="item.img" />
              <span>{{ms_localize(item.title)}}</span>
          </div>          
        </div>

        <div :class="['platformBarContainer',plaformIndex>-1 ? 'mounted':'']">
          <!-- v-bind:affectOtherSections = "false" -->
          <platformbar 
            v-bind:sectionIndex = "5"     
            v-bind:affectOtherSections = "true"       
            skinMode = "light"            
            @platform-change="onPlatformChange" 
            @item-change="onItemChange">
          </platformbar>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import splitter from "@/views/com/splitter.vue";
import platformbar from "@/views/com/platformbar.vue";

export default {
    name: "Coverscrews",
    components:{platformbar,splitter},
    props: {
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {
            plaformIndex:-1,
            infoImg:'',
            itemsArray:[],
            isImgFadeout:true
        }
    },
    methods:
    {
      onPlatformChange(plaformIndex)
      {
        var vm = this;        
        vm.isImgFadeout = true;
        
        setTimeout(() => {
          vm.plaformIndex = plaformIndex;
          vm.itemsArray = this.sectionData.platforms[plaformIndex].items;
        }, 500);

        setTimeout(() => {
          vm.isImgFadeout = false;
        }, 1100);

      },
      onItemChange(catalogNo)
      {
        //nothing
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["minisite_data"]),
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};

</script>


<style>
    @property --c {
      syntax: '<color>';
      inherits: false;
      initial-value: red;
    }

    .csSec
    {      
        position:relative;
        width: 100vw;
        height: calc(100% + 2px);
        
        z-index: 100;
        display: grid;
        align-items: center;

        background-color: var(--graybg1);
    }
    
    .csSec.platform_0{--c:#2a2512;}
    .csSec.platform_1{--c:#241128;}
    .csSec.platform_2{--c:#0f250e;}
    .___csSec.platform_3{--c:#0f250e;}

    .csSec .container
    {
      width: 100vw;
    }
    .csSec .title
    {
        font-size: 22px !important;
        font-weight: 100 !important;        
        letter-spacing: -0.5px;
        color: #fff;
        text-align:center;        
        position:absolute;
        top:0px;left: 0px;
        /*padding-left: max(180px, 10vw);*/
        top:100px;width: 100%;
        
    }
    .csSec .info
    {
        position:absolute;
        top:50%;left: 0px;
        transform: translateY(-50%);
        padding-left: max(180px, 10vw);        
    }
    .csSec .info .infItem:nth-child(1)
    {
      font-weight: 400;      
    }
    .csSec .info .infItem
    {
      padding-top: 3px;
        font-size: 14px;
        text-align: left;        
        color: #fff;
    }


    .csSec .platformBarContainer
    {
      position: absolute;
      top:50%;
      transform: translateY(-50%);
      width: 100%;
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    }
    .csSec .platformBarContainer.mounted
    {
      top:calc(100vh - 120px);
    }    







    .csSec .csImgCont
    {
      position: absolute;top:47%;transform: translateY(-50%);
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.4s;
    }
    .csSec .csImgCont.csImgFadeout
    {
      opacity: 0;
    }


    .csSec .csImgCont .csImgItem
    {
      display: inline-block;
    }    
    .csSec .csImgCont .csImgItem img
    {
      width: 70px;height: auto;
      margin: 0px 80px;
    }    
    .csSec .csImgCont .csImgItem span
    {
      width: 100%;text-align: center;clear: both;
      display: block;
      color:#202020;
      font-size: 16px;
      padding-top: 10px;      
    }    
    .csImgCont .itemImg
    {
      height: 46vh;width:auto;
    }
    .csImgCont .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #fff;font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    .csSec
    {
      min-height: 30vh;
      display: block;
    }
    .csSec .sectionTitle
    {
        position: initial;
        padding-top: 100px;
    }
    .csSec .csImgCont
    {
      position: initial;
      display: block;
      clear: both;
      float: left;
      padding-top: 50px;
      padding-bottom: 30px;
      transform: none;      
    }
    .csSec .csImgCont .csImgItem {
        display: inline-block;width: 45vw;
        padding-bottom: 20px;
    }    
    .csSec .csImgCont .csImgItem img {
      width: 50px;
      height: auto;
      margin: 0px 50px;
    }    
    .csSec .platformBarContainer
    {
      position: static;
      transform: none;
      padding: 50px 0px 100px 0px;
    }


  }  
</style>